import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateKeyForbiddenAccess } from '@job-v2/ats-utils';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-forbidden-access',
  imports: [
    ButtonModule,
    TranslateModule
  ],
  templateUrl: './forbidden-access.component.html',
  styleUrl: './forbidden-access.component.scss'
})
export class ForbiddenAccessComponent {

  public readonly forbiddenAccessKeys = TranslateKeyForbiddenAccess;
  private authService = inject(AuthService)

  constructor(private readonly router: Router, 
    private readonly location: Location
  ) { }

  goBack() {
    this.router.navigate(['../../'])
  }

  goHome() {
    this.authService.handleRedirectionBasedOnRole()
  }

}
